/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../connect/v2/resources/error';
import '../items/items';
import '../paymentreporter/service';
import '../channels/channels';
import '../common/currency';
import '../paymentreporter/report/fee_report';
import '../paymentbalances/common';
import '../payouts/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "salesreporter": {
        "nested": {
          "service": {
            "nested": {
              "ReportRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reportingHours": {
                    "type": ".squareup.salesreporter.service.ZonedTimeInterval",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 5,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.salesreporter.service.FilterByValue",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "timelinePeriod": {
                    "type": ".squareup.salesreporter.service.TimelinePeriod",
                    "id": 7,
                    "rule": "optional"
                  },
                  "weeklyStartDay": {
                    "type": ".squareup.salesreporter.service.DayOfWeek",
                    "id": 15,
                    "rule": "optional"
                  },
                  "weeklyStartDayV2": {
                    "type": ".squareup.common.time.DayOfWeek",
                    "id": 16,
                    "rule": "optional"
                  },
                  "selectedMetrics": {
                    "type": ".squareup.salesreporter.service.MetricName",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "groupByType": {
                    "type": ".squareup.salesreporter.service.GroupByType",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "pageParams": {
                    "type": ".squareup.salesreporter.service.PageParams",
                    "id": 10,
                    "rule": "optional"
                  },
                  "dataSource": {
                    "type": ".squareup.salesreporter.service.DataSource",
                    "id": 11,
                    "rule": "optional"
                  },
                  "localReportingHours": {
                    "type": ".squareup.salesreporter.service.LocalTimeInterval",
                    "id": 12,
                    "rule": "optional"
                  },
                  "internalRequestOptions": {
                    "type": ".squareup.salesreporter.service.InternalRequestOptions",
                    "id": 14,
                    "rule": "optional"
                  },
                  "fillEmptyBuckets": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "clampBuckets": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "TimeZone": {
                "fields": {
                  "tzName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LocalTimeInterval": {
                "fields": {
                  "inclusiveStart": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "exclusiveEnd": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ZonedTimeInterval": {
                "fields": {
                  "start": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "end": {
                    "type": ".squareup.common.time.LocalTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "InternalRequestOptions": {
                "fields": {
                  "includeOrderIds": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "orderIds": {
                    "type": "string",
                    "id": 13,
                    "rule": "repeated"
                  }
                }
              },
              "AvailableFiltersRequest": {
                "fields": {
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "requestedFilters": {
                    "type": ".squareup.salesreporter.service.FilterByType",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "dataSource": {
                    "type": ".squareup.salesreporter.service.DataSource",
                    "id": 5,
                    "rule": "optional"
                  },
                  "internalOptions": {
                    "type": ".squareup.salesreporter.service.InternalRequestOptions",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "PageParams": {
                "fields": {
                  "pageSize": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "afterCursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReportResponse": {
                "fields": {
                  "reportData": {
                    "type": ".squareup.salesreporter.service.ReportData",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "pageInfo": {
                    "type": ".squareup.salesreporter.service.PageInfo",
                    "id": 3,
                    "rule": "optional"
                  },
                  "internalResponseOptions": {
                    "type": ".squareup.salesreporter.service.InternalResponseOptions",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "InternalResponseOptions": {
                "fields": {
                  "orderIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "AvailableFiltersResponse": {
                "fields": {
                  "availableFilters": {
                    "type": ".squareup.salesreporter.service.FilterByValue",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PageInfo": {
                "fields": {
                  "hasNextPage": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endCursor": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FilterByType": {
                "values": {
                  "FILTER_BY_TYPE_DO_NOT_USE": 0,
                  "FILTER_SALES_CHANNEL": 1,
                  "FILTER_DEVICE_ID": 2,
                  "FILTER_DEVICE_NICKNAME": 3,
                  "FILTER_ORDER_SOURCE_NAME": 4,
                  "FILTER_ITEM_TYPE": 5,
                  "FILTER_TEAM_MEMBER_COLLECTED_TO": 6,
                  "FILTER_TEAM_MEMBER_COLLECTED_BY_SINGLETON": 12,
                  "FILTER_TEAM_MEMBER_ATTRIBUTED_TO": 7,
                  "FILTER_CHECK_STATE": 8,
                  "FILTER_ITEM_CATEGORY": 9,
                  "FILTER_LOCATION": 10,
                  "FILTER_CHECK_STATE_V2": 13,
                  "FILTER_FULFILLMENT_METHOD": 14,
                  "FILTER_FULFILLMENT_TYPE": 15
                }
              },
              "ChannelList": {
                "fields": {
                  "channels": {
                    "type": ".squareup.salesreporter.service.Channel",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "DeviceList": {
                "fields": {
                  "devices": {
                    "type": ".squareup.salesreporter.service.Device",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "OrderSourceList": {
                "fields": {
                  "orderSources": {
                    "type": ".squareup.salesreporter.service.OrderSource",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "LocationList": {
                "fields": {
                  "locations": {
                    "type": ".squareup.salesreporter.service.Location",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ItemTypeList": {
                "fields": {
                  "itemTypes": {
                    "type": ".squareup.api.items.Item.Type",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "EmployeeList": {
                "fields": {
                  "employees": {
                    "type": ".squareup.salesreporter.service.Employee",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CheckStateList": {
                "fields": {
                  "checkStates": {
                    "type": ".squareup.salesreporter.service.CheckState",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "CheckStateV2List": {
                "fields": {
                  "checkStates": {
                    "type": ".squareup.salesreporter.service.CheckStateV2",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ItemCategoryList": {
                "fields": {
                  "itemCategories": {
                    "type": ".squareup.salesreporter.service.ItemCategory",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PaymentMethodList": {
                "fields": {
                  "paymentMethods": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FulfillmentMethodList": {
                "fields": {
                  "fulfillmentMethods": {
                    "type": ".squareup.salesreporter.service.FulfillmentMethod",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FulfillmentTypeList": {
                "fields": {
                  "fulfillmentTypes": {
                    "type": ".squareup.salesreporter.service.FulfillmentType",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FilterByValue": {
                "fields": {
                  "salesChannels": {
                    "type": ".squareup.salesreporter.service.ChannelList",
                    "id": 1
                  },
                  "devices": {
                    "type": ".squareup.salesreporter.service.DeviceList",
                    "id": 2
                  },
                  "orderSources": {
                    "type": ".squareup.salesreporter.service.OrderSourceList",
                    "id": 3
                  },
                  "itemType": {
                    "type": ".squareup.salesreporter.service.ItemTypeList",
                    "id": 4
                  },
                  "collectedByTeamMembers": {
                    "type": ".squareup.salesreporter.service.EmployeeList",
                    "id": 5
                  },
                  "collectedByTeamMembersSingleton": {
                    "type": ".squareup.salesreporter.service.TeamMemberList",
                    "id": 13
                  },
                  "attributedByTeamMembers": {
                    "type": ".squareup.salesreporter.service.EmployeeList",
                    "id": 6
                  },
                  "checkStates": {
                    "type": ".squareup.salesreporter.service.CheckStateList",
                    "id": 7
                  },
                  "deviceCredentials": {
                    "type": ".squareup.salesreporter.service.DeviceList",
                    "id": 8
                  },
                  "locations": {
                    "type": ".squareup.salesreporter.service.LocationList",
                    "id": 9
                  },
                  "itemCategories": {
                    "type": ".squareup.salesreporter.service.ItemCategoryList",
                    "id": 10
                  },
                  "houseAccountInvoice": {
                    "type": ".squareup.salesreporter.service.HouseAccountInvoice",
                    "id": 12
                  },
                  "checkStatesV2": {
                    "type": ".squareup.salesreporter.service.CheckStateV2List",
                    "id": 14
                  },
                  "paymentMethods": {
                    "type": ".squareup.salesreporter.service.PaymentMethodList",
                    "id": 15
                  },
                  "fulfillmentMethods": {
                    "type": ".squareup.salesreporter.service.FulfillmentMethodList",
                    "id": 16
                  },
                  "fulfillmentTypes": {
                    "type": ".squareup.salesreporter.service.FulfillmentTypeList",
                    "id": 17
                  }
                },
                "nested": {
                  "filter_value": {
                    "oneof": ["salesChannels", "devices", "orderSources", "itemType", "collectedByTeamMembers", "collectedByTeamMembersSingleton", "attributedByTeamMembers", "checkStates", "deviceCredentials", "locations", "itemCategories", "houseAccountInvoice", "checkStatesV2", "paymentMethods", "fulfillmentMethods", "fulfillmentTypes"]
                  }
                }
              },
              "Channel": {
                "fields": {
                  "channelName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "channelId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "channelType": {
                    "type": ".squareup.salesreporter.service.ChannelType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "channelScope": {
                    "type": ".squareup.salesreporter.service.ChannelScope",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "channelReference": {
                    "type": ".squareup.salesreporter.service.ChannelReference",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "ChannelType": {
                "values": {
                  "CHANNEL_TYPE_DO_NOT_USE": 0,
                  "CHANNEL_TYPE_MARKETING": 1,
                  "CHANNEL_TYPE_SALES": 2
                }
              },
              "ChannelScope": {
                "values": {
                  "CHANNEL_SCOPE_DO_NOT_USE": 0,
                  "CHANNEL_SCOPE_ORDER": 1
                }
              },
              "ChannelReference": {
                "fields": {
                  "type": {
                    "type": ".squareup.channels.Reference.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "onlineStoreUrl": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "isOnlineStoreKioskSite": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "Device": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OrderSource": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentMethod": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentType": {
                "values": {
                  "FULFILLMENT_NONE": 0,
                  "FULFILLMENT_PICKUP": 1,
                  "FULFILLMENT_DELIVERY": 2,
                  "FULFILLMENT_SHIPMENT": 3,
                  "FULFILLMENT_DIGITAL": 4,
                  "FULFILLMENT_IN_STORE": 5,
                  "FULFILLMENT_MULTIPLE": 6,
                  "FULFILLMENT_SIMPLE": 7,
                  "FULFILLMENT_BOOKING": 8,
                  "FULFILLMENT_CUSTOM": 9,
                  "FULFILLMENT_MANAGED_DELIVERY": 10
                }
              },
              "Location": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "Employee": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ItemCategory": {
                "fields": {
                  "nameOrTranslationType": {
                    "type": ".squareup.salesreporter.service.NameOrTranslationType",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "HouseAccountInvoice": {
                "values": {
                  "HOUSE_ACCOUNT_INVOICE_UNKNOWN": 0,
                  "HOUSE_ACCOUNT_INVOICE": 1,
                  "NON_HOUSE_ACCOUNT_INVOICE": 2
                }
              },
              "SurchargeType": {
                "values": {
                  "UNKNOWN": 0,
                  "AUTO_GRATUITY": 1,
                  "CUSTOM": 2,
                  "NO_SURCHARGE_TYPE": 3
                }
              },
              "CheckState": {
                "values": {
                  "CLOSED": 0,
                  "OPEN": 1,
                  "ALL": 2
                }
              },
              "CheckStateV2": {
                "values": {
                  "CHECK_STATE_V2_DO_NOT_USE": 0,
                  "AWAITING_CAPTURE_CHECK_STATE": 1,
                  "CLOSED_CHECK_STATE": 2,
                  "OPEN_CHECK_STATE": 3
                }
              },
              "TranslationType": {
                "values": {
                  "CUSTOM_AMOUNT_ITEM": 0,
                  "UNITEMIZED_TAX": 1,
                  "DEFAULT_DISCOUNT": 2,
                  "DEFAULT_ITEM": 3,
                  "DEFAULT_SALES_TAX": 4,
                  "DEFAULT_TIP": 5,
                  "CHANGE": 6,
                  "REFUND": 7,
                  "CASH_REFUND": 8,
                  "INCLUSIVE_TAX": 9,
                  "DEFAULT_ITEM_MODIFIER": 10,
                  "CREDIT": 11,
                  "SWEDISH_ROUNDING": 12,
                  "SURCHARGE": 13,
                  "DEFAULT_DEVICE": 14,
                  "NO_CATEGORY": 15,
                  "NO_DISCOUNT": 16,
                  "NO_MODIFIER": 17,
                  "NO_SUBUNIT": 18,
                  "NO_MOBILE_STAFF": 19,
                  "NO_EMPLOYEE": 20,
                  "NAMELESS_EMPLOYEE": 78,
                  "CUSTOM_AMOUNT_ITEM_VARIATION": 21,
                  "DEFAULT_ITEM_VARIATION": 22,
                  "NO_MODIFIER_SET": 23,
                  "DEFAULT_MODIFIER_SET": 24,
                  "NO_TAX": 25,
                  "NO_DINING_OPTION": 26,
                  "NO_GIFT_CARD": 27,
                  "NO_VOID_REASON": 28,
                  "NO_COMP_REASON": 29,
                  "DEFAULT_COMP_REASON": 30,
                  "NO_COMP": 31,
                  "TICKET_NAME": 32,
                  "TICKET_GROUP_NAME": 33,
                  "NO_TICKET_GROUP": 34,
                  "NO_DEVICE_CREDENTIAL": 35,
                  "DEFAULT_DEVICE_CREDENTIAL": 36,
                  "NO_EMPLOYEE_ROLE": 37,
                  "EMPLOYEE_ROLE_ACCOUNT_OWNER_ROLE": 38,
                  "EMPLOYEE_ROLE_OWNER_ROLE": 39,
                  "EMPLOYEE_ROLE_DELETED_ROLE": 40,
                  "EMPLOYEE_ROLE_MOBILE_STAFF_ROLE": 41,
                  "NO_CONVERSATIONAL_MODE": 42,
                  "NO_MENU": 43,
                  "NO_TICKET_TEMPLATE": 44,
                  "NO_TICKET_TEMPLATE_CUSTOM_CHECK": 45,
                  "NO_PAYMENT_SOURCE_NAME": 46,
                  "UNKNOWN_PAYMENT_SOURCE_NAME": 47,
                  "NO_CONTACT_TOKEN": 48,
                  "NO_REPORTING_GROUP": 49,
                  "NO_SURCHARGE": 50,
                  "SURCHARGE_AUTO_GRATUITY": 51,
                  "DEFAULT_SURCHARGE_NAME": 52,
                  "DEFAULT_ORDER_SOURCE_NAME": 53,
                  "ORDER_SOURCE_REGISTER": 54,
                  "ORDER_SOURCE_MARKET": 55,
                  "ORDER_SOURCE_ORDER": 56,
                  "ORDER_SOURCE_EXTERNAL_API": 57,
                  "ORDER_SOURCE_APPOINTMENTS": 58,
                  "ORDER_SOURCE_INVOICES": 59,
                  "ORDER_SOURCE_BILLING": 60,
                  "ORDER_SOURCE_STORE": 61,
                  "ORDER_SOURCE_ONLINE_STORE": 62,
                  "ORDER_SOURCE_STARBUCKS": 63,
                  "ORDER_SOURCE_WHITE_LABEL": 64,
                  "ORDER_SOURCE_PAYROLL": 65,
                  "ORDER_SOURCE_CAPITAL": 66,
                  "ORDER_SOURCE_TERMINAL": 67,
                  "ORDER_SOURCE_EGIFTING": 68,
                  "ORDER_SOURCE_CASH": 69,
                  "ORDER_SOURCE_REGISTER_HARDWARE": 70,
                  "ORDER_SOURCE_SUBSCRIPTIONS": 74,
                  "ORDER_SOURCE_FNB_KIOSK": 75,
                  "DEFAULT_MEASUREMENT_UNIT": 71,
                  "NO_VENDOR": 72,
                  "UNKNOWN_VENDOR": 73,
                  "DEFAULT_COMBO": 76,
                  "NO_CHANNEL_ATTRIBUTION": 77,
                  "UNKNOWN_CHANNEL_ATTRIBUTION": 79,
                  "MULTIPLE_EMPLOYEES": 80,
                  "UNKNOWN_EMPLOYEE": 81,
                  "NO_EMPLOYEE_JOB": 82,
                  "NO_FULFILLMENT_METHOD": 83
                }
              },
              "TeamMemberTranslationTypes": {
                "values": {
                  "DEFAULT_TEAM_MEMBER_DO_NOT_USE": 0,
                  "NO_TEAM_MEMBER": 1,
                  "MULTIPLE_TEAM_MEMBERS": 2,
                  "UNKNOWN_TEAM_MEMBER": 3
                }
              },
              "TeamMemberName": {
                "fields": {
                  "givenName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "familyName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TeamMember": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": ".squareup.salesreporter.service.TeamMemberName",
                    "id": 2
                  },
                  "translationType": {
                    "type": ".squareup.salesreporter.service.TeamMemberTranslationTypes",
                    "id": 3
                  }
                },
                "nested": {
                  "name_or_translation_type": {
                    "oneof": ["name", "translationType"]
                  }
                }
              },
              "TeamMemberList": {
                "fields": {
                  "teamMembers": {
                    "type": ".squareup.salesreporter.service.TeamMember",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "NameOrTranslationType": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "translationType": {
                    "type": ".squareup.salesreporter.service.TranslationType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TimelinePeriod": {
                "values": {
                  "TIMELINE_PERIOD_DO_NOT_USE": 0,
                  "NONE": 1,
                  "DAILY": 2,
                  "WEEKLY": 3,
                  "MONTHLY": 4,
                  "HOURLY": 5
                }
              },
              "ReportingCounts": {
                "fields": {
                  "autoGratuityMoneyCount": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "autoGratuityTaxMoneyCount": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cardSurchargeMoneyCount": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "compsMoneyCount": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "depositsRedeemedCount": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "discountsMoneyCount": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "giftCardSalesMoneyCount": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "itemSalesMoneyCount": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "itemizedReturnsCount": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "netSalesCount": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "netSalesWithTaxCount": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "refundsByAmountMoneyCount": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "returnedAutoGratuityMoneyCount": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "returnedServiceChargesMoneyCount": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "salesTaxMoneyCount": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "serviceChargesMoneyCount": {
                    "type": "int64",
                    "id": 16,
                    "rule": "optional"
                  },
                  "serviceChargesOnlyMoneyCount": {
                    "type": "int64",
                    "id": 17,
                    "rule": "optional"
                  },
                  "subtotalSalesCount": {
                    "type": "int64",
                    "id": 18,
                    "rule": "optional"
                  },
                  "swedishCashRoundingMoneyCount": {
                    "type": "int64",
                    "id": 19,
                    "rule": "optional"
                  },
                  "tipsMoneyCount": {
                    "type": "int64",
                    "id": 20,
                    "rule": "optional"
                  },
                  "topLineProductSalesCount": {
                    "type": "int64",
                    "id": 21,
                    "rule": "optional"
                  },
                  "totalCollectedMoneyCount": {
                    "type": "int64",
                    "id": 22,
                    "rule": "optional"
                  },
                  "totalSalesCount": {
                    "type": "int64",
                    "id": 23,
                    "rule": "optional"
                  },
                  "itemSalesWithoutExchangesCount": {
                    "type": "int64",
                    "id": 24,
                    "rule": "optional"
                  },
                  "itemSalesExchangesCount": {
                    "type": "int64",
                    "id": 25,
                    "rule": "optional"
                  }
                }
              },
              "Metric": {
                "fields": {
                  "grossSalesSum": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalSalesAvg": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "netSalesSum": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "netSalesWithTaxSum": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "grossSaleReturnsSum": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "discountAndCompsSum": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "salesTaxSum": {
                    "type": ".squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "tipsSum": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "giftCardSalesSum": {
                    "type": ".squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "refundsByAmountSum": {
                    "type": ".squareup.common.Money",
                    "id": 12,
                    "rule": "optional"
                  },
                  "swedishCashRoundingSum": {
                    "type": ".squareup.common.Money",
                    "id": 13,
                    "rule": "optional"
                  },
                  "totalSalesSum": {
                    "type": ".squareup.common.Money",
                    "id": 14,
                    "rule": "optional"
                  },
                  "itemSalesSum": {
                    "type": ".squareup.common.Money",
                    "id": 15,
                    "rule": "optional"
                  },
                  "serviceChargesSum": {
                    "type": ".squareup.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "mostRecentSale": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 17,
                    "rule": "optional"
                  },
                  "initialFeeSum": {
                    "type": ".squareup.common.Money",
                    "id": 18,
                    "rule": "optional"
                  },
                  "taxOnInitialFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 19,
                    "rule": "optional"
                  },
                  "feeAdjustmentsSum": {
                    "type": ".squareup.common.Money",
                    "id": 20,
                    "rule": "optional"
                  },
                  "taxOnFeeAdjustmentsSum": {
                    "type": ".squareup.common.Money",
                    "id": 21,
                    "rule": "optional"
                  },
                  "freeProcessingFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 22,
                    "rule": "optional"
                  },
                  "squareProcessingFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 23,
                    "rule": "optional"
                  },
                  "taxOn_SquareProcessingFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 24,
                    "rule": "optional"
                  },
                  "thirdPartyFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 25,
                    "rule": "optional"
                  },
                  "thirdPartyFeesGroupedByEntityName": {
                    "type": ".squareup.salesreporter.service.ThirdPartyFeeDetail",
                    "id": 26,
                    "rule": "repeated"
                  },
                  "totalProcessingFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 27,
                    "rule": "optional"
                  },
                  "totalOrderCount": {
                    "type": "int64",
                    "id": 28,
                    "rule": "optional"
                  },
                  "itemCount": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "totalSalesCount": {
                    "type": "int64",
                    "id": 30,
                    "rule": "optional"
                  },
                  "serviceChargeOnlySum": {
                    "type": ".squareup.common.Money",
                    "id": 31,
                    "rule": "optional"
                  },
                  "cardSurchargeSum": {
                    "type": ".squareup.common.Money",
                    "id": 32,
                    "rule": "optional"
                  },
                  "autoGratuitySum": {
                    "type": ".squareup.common.Money",
                    "id": 33,
                    "rule": "optional"
                  },
                  "discountsSum": {
                    "type": ".squareup.common.Money",
                    "id": 34,
                    "rule": "optional"
                  },
                  "compsSum": {
                    "type": ".squareup.common.Money",
                    "id": 35,
                    "rule": "optional"
                  },
                  "totalCollected": {
                    "type": ".squareup.common.Money",
                    "id": 36,
                    "rule": "optional"
                  },
                  "totalCollectedByMethod": {
                    "type": ".squareup.salesreporter.service.TotalCollectedByMethod",
                    "id": 37,
                    "rule": "optional"
                  },
                  "netCollectedSum": {
                    "type": ".squareup.common.Money",
                    "id": 38,
                    "rule": "optional"
                  },
                  "grossSalesMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 39,
                    "rule": "optional"
                  },
                  "returnsMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 40,
                    "rule": "optional"
                  },
                  "netSalesMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 41,
                    "rule": "optional"
                  },
                  "taxesMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 42,
                    "rule": "optional"
                  },
                  "netSalesWithTaxMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 43,
                    "rule": "optional"
                  },
                  "netAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 44,
                    "rule": "optional"
                  },
                  "customServiceCharges": {
                    "type": ".squareup.salesreporter.service.CustomServiceChargeDetail",
                    "id": 45,
                    "rule": "optional"
                  },
                  "customServiceChargesPlusCardSurchargeSum": {
                    "type": ".squareup.common.Money",
                    "id": 46,
                    "rule": "optional"
                  },
                  "tipPlusNetAutoGratuitySum": {
                    "type": ".squareup.common.Money",
                    "id": 47,
                    "rule": "optional"
                  },
                  "partialPaymentAmountsSum": {
                    "type": ".squareup.common.Money",
                    "id": 48,
                    "rule": "optional"
                  },
                  "pendingRefundsSum": {
                    "type": ".squareup.common.Money",
                    "id": 49,
                    "rule": "optional"
                  },
                  "paidOnOtherDaysSum": {
                    "type": ".squareup.common.Money",
                    "id": 50,
                    "rule": "optional"
                  },
                  "nonTransferableCollectedSum": {
                    "type": ".squareup.common.Money",
                    "id": 51,
                    "rule": "optional"
                  },
                  "netTransferableCollectedSum": {
                    "type": ".squareup.common.Money",
                    "id": 52,
                    "rule": "optional"
                  },
                  "netTransferableSum": {
                    "type": ".squareup.common.Money",
                    "id": 53,
                    "rule": "optional"
                  },
                  "netCollectedMinusPendingRefundsSum": {
                    "type": ".squareup.common.Money",
                    "id": 54,
                    "rule": "optional"
                  },
                  "paymentsByPaymentMethod": {
                    "type": ".squareup.salesreporter.service.PaymentMethodBreakdown",
                    "id": 55,
                    "rule": "optional"
                  },
                  "refundsByPaymentMethod": {
                    "type": ".squareup.salesreporter.service.PaymentMethodBreakdown",
                    "id": 56,
                    "rule": "optional"
                  },
                  "feesByType": {
                    "type": ".squareup.salesreporter.service.FeeBreakdown",
                    "id": 57,
                    "rule": "optional"
                  },
                  "giftCardLoadFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 58,
                    "rule": "optional"
                  },
                  "taxOnGiftCardLoadFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 64,
                    "rule": "optional"
                  },
                  "depositsRedeemed": {
                    "type": ".squareup.common.Money",
                    "id": 59,
                    "rule": "optional"
                  },
                  "reportingCounts": {
                    "type": ".squareup.salesreporter.service.ReportingCounts",
                    "id": 60,
                    "rule": "optional"
                  },
                  "totalDeferredSales": {
                    "type": ".squareup.common.Money",
                    "id": 61,
                    "rule": "optional"
                  },
                  "appSubscriptionMarketplaceFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 65,
                    "rule": "optional"
                  },
                  "taxOnAppSubscriptionMarketplaceFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 66,
                    "rule": "optional"
                  },
                  "internationalTransactionFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 67,
                    "rule": "optional"
                  },
                  "taxOnInternationalTransactionFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 68,
                    "rule": "optional"
                  },
                  "baseSquareProcessingFeesSum": {
                    "type": ".squareup.common.Money",
                    "id": 69,
                    "rule": "optional"
                  },
                  "coverCount": {
                    "type": "int64",
                    "id": 70,
                    "rule": "optional"
                  }
                }
              },
              "PaymentMethodBreakdown": {
                "fields": {
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "paymentMethods": {
                    "type": ".squareup.salesreporter.service.PaymentMethodAmount",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "totalTransferableAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "totalNonTransferableAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PaymentMethodAmount": {
                "fields": {
                  "paymentMethod": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferableAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "nonTransferableAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FeeBreakdown": {
                "fields": {
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fees": {
                    "type": ".squareup.salesreporter.service.FeeAmount",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FeeAmount": {
                "fields": {
                  "feeType": {
                    "type": ".squareup.paymentreporter.report.feereport.FeeType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CustomServiceChargeDetail": {
                "fields": {
                  "totalSum": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customServiceChargesByName": {
                    "type": ".squareup.salesreporter.service.NameToServiceCharge",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "NameToServiceCharge": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "serviceChargeSum": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TotalCollectedByMethod": {
                "fields": {
                  "totalCollectedByPaymentMethod": {
                    "type": ".squareup.salesreporter.service.PaymentMethodToCollected",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalTransferableAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "totalNonTransferableAmount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "OtherPaymentBreakdown": {
                "fields": {
                  "totalCollectedBySource": {
                    "type": ".squareup.salesreporter.service.SourceToCollected",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "SourceToCollected": {
                "fields": {
                  "sourceName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalCollected": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PaymentMethodToCollected": {
                "fields": {
                  "paymentMethod": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalCollected": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalTransferableCollected": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalNonTransferableCollected": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "otherPaymentBreakdown": {
                    "type": ".squareup.salesreporter.service.OtherPaymentBreakdown",
                    "id": 3
                  }
                },
                "nested": {
                  "breakdown": {
                    "oneof": ["otherPaymentBreakdown"]
                  }
                }
              },
              "ThirdPartyFeeTranslationType": {
                "values": {
                  "DO_NOT_USE_THIRD_PARTY_FEE_TRANSLATION_TYPE": 0,
                  "ECOM_DELIVERY_FEES": 1
                }
              },
              "ThirdPartyFeeDetail": {
                "fields": {
                  "feesSum": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "entityName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "translationType": {
                    "type": ".squareup.salesreporter.service.ThirdPartyFeeTranslationType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MetricName": {
                "values": {
                  "METRIC_NAME_DO_NOT_USE": 0,
                  "GROSS_SALES_SUM": 1,
                  "NET_SALES_WITH_TAX_SUM": 4,
                  "TOTAL_SALES_AVG": 2,
                  "NET_SALES_SUM": 3,
                  "GROSS_SALE_RETURNS_SUM": 7,
                  "DISCOUNT_AND_COMPS_SUM": 8,
                  "SALES_TAX_SUM": 9,
                  "TIPS_SUM": 10,
                  "GIFT_CARD_SALES_SUM": 11,
                  "REFUNDS_BY_AMOUNT_SUM": 12,
                  "SWEDISH_CASH_ROUNDING_SUM": 13,
                  "TOTAL_SALES_SUM": 14,
                  "ITEM_SALES_SUM": 15,
                  "SERVICE_CHARGES_SUM": 16,
                  "MOST_RECENT_SALE": 17,
                  "INITIAL_FEES_SUM": 18,
                  "TAX_ON_INITIAL_FEES_SUM": 19,
                  "FEE_ADJUSTMENTS_SUM": 20,
                  "TAX_ON_FEE_ADJUSTMENTS_SUM": 21,
                  "FREE_PROCESSING_FEES_SUM": 22,
                  "SQUARE_PROCESSING_FEES_SUM": 23,
                  "TAX_ON_SQUARE_PROCESSING_FEES_SUM": 24,
                  "THIRD_PARTY_FEES_SUM": 25,
                  "THIRD_PARTY_FEES_GROUPED_BY_ENTITY_NAME": 26,
                  "TOTAL_PROCESSING_FEES_SUM": 27,
                  "TOTAL_ORDER_COUNT": 28,
                  "ITEM_COUNT": 29,
                  "TOTAL_SALES_COUNT": 30,
                  "SERVICE_CHARGES_ONLY_SUM": 31,
                  "CARD_SURCHARGE_SUM": 32,
                  "AUTO_GRATUITY_SUM": 33,
                  "DISCOUNTS_SUM": 34,
                  "COMPS_SUM": 35,
                  "TOTAL_COLLECTED_SUM": 36,
                  "TOTAL_COLLECTED_BY_PAYMENT_METHOD_SUM": 37,
                  "NET_COLLECTED_SUM": 38,
                  "GROSS_SALES_MINUS_AUTO_GRATUITY": 39,
                  "RETURNS_MINUS_AUTO_GRATUITY": 40,
                  "NET_SALES_MINUS_AUTO_GRATUITY": 43,
                  "TAXES_MINUS_AUTO_GRATUITY": 44,
                  "NET_SALES_WITH_TAX_MINUS_AUTO_GRATUITY": 45,
                  "NET_AUTO_GRATUITY": 46,
                  "CUSTOM_SERVICE_CHARGES": 47,
                  "CUSTOM_SERVICE_CHARGES_PLUS_CARD_SURCHARGE_SUM": 48,
                  "TIPS_PLUS_NET_AUTO_GRATUITY_SUM": 49,
                  "PARTIAL_PAYMENT_AMOUNTS_SUM": 50,
                  "PENDING_REFUNDS_SUM": 51,
                  "PAID_ON_OTHER_DAYS_SUM": 52,
                  "NON_TRANSFERABLE_COLLECTED_SUM": 53,
                  "NET_TRANSFERABLE_COLLECTED_SUM": 54,
                  "NET_TRANSFERABLE_SUM": 55,
                  "NET_COLLECTED_MINUS_PENDING_REFUND_SUM": 56,
                  "PAYMENTS_BY_PAYMENT_METHOD": 57,
                  "REFUNDS_BY_PAYMENT_METHOD": 58,
                  "FEES_BY_TYPE": 59,
                  "GIFT_CARD_LOAD_FEES_SUM": 60,
                  "TAX_ON_GIFT_CARD_LOAD_FEES_SUM": 64,
                  "DEPOSITS_REDEEMED": 61,
                  "REPORTING_COUNTS": 62,
                  "TOTAL_DEFERRED_SALES": 63,
                  "APP_SUBSCRIPTION_MARKETPLACE_FEES_SUM": 65,
                  "TAX_ON_APP_SUBSCRIPTION_MARKETPLACE_FEES_SUM": 66,
                  "INTERNATIONAL_TRANSACTION_FEES_SUM": 67,
                  "TAX_ON_INTERNATIONAL_TRANSACTION_FEES_SUM": 68,
                  "BASE_SQUARE_PROCESSING_FEES_SUM": 69,
                  "COVER_COUNT": 70
                }
              },
              "GroupByType": {
                "values": {
                  "GROUP_BY_TYPE_DO_NOT_USE": 0,
                  "GROUP_BY_LOCATION_ID": 1,
                  "GROUP_BY_DEVICE_ID": 2,
                  "GROUP_BY_DEVICE_NICKNAME": 3,
                  "GROUP_BY_ORDER_SOURCE_NAME": 4,
                  "GROUP_BY_ITEM_TYPE": 5,
                  "GROUP_BY_TEAM_MEMBER_COLLECTED_TO": 6,
                  "GROUP_BY_TEAM_MEMBER_COLLECTED_BY_SINGLETON": 16,
                  "GROUP_BY_TEAM_MEMBER_ATTRIBUTED_TO": 7,
                  "GROUP_BY_SALES_CHANNEL": 8,
                  "GROUP_BY_CHECK_STATE": 9,
                  "GROUP_BY_SURCHARGE_TYPE": 10,
                  "GROUP_BY_ITEM_CATEGORY": 11,
                  "GROUP_BY_ORDER_ID": 12,
                  "GROUP_BY_HOUR_OF_DAY": 14,
                  "GROUP_BY_DAY_OF_WEEK": 15,
                  "GROUP_BY_DAY_OF_WEEK_V2": 17,
                  "GROUP_BY_PAYMENT_METHOD": 18,
                  "GROUP_BY_MONTH_OF_YEAR": 19,
                  "GROUP_BY_YEAR": 20,
                  "GROUP_BY_DATE": 21,
                  "GROUP_BY_HOUR": 22,
                  "GROUP_BY_WEEK": 23,
                  "GROUP_BY_MONTH": 24,
                  "GROUP_BY_FULFILLMENT_METHOD": 25,
                  "GROUP_BY_FULFILLMENT_TYPE": 26
                }
              },
              "DayOfWeek": {
                "values": {
                  "DEFAULT_DAY_OF_WEEK_DO_NOT_USE": 0,
                  "SUNDAY": 1,
                  "MONDAY": 2,
                  "TUESDAY": 3,
                  "WEDNESDAY": 4,
                  "THURSDAY": 5,
                  "FRIDAY": 6,
                  "SATURDAY": 7
                }
              },
              "GroupByValue": {
                "fields": {
                  "locationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemType": {
                    "type": ".squareup.api.items.Item.Type",
                    "id": 2,
                    "rule": "optional"
                  },
                  "orderSource": {
                    "type": ".squareup.salesreporter.service.OrderSource",
                    "id": 3,
                    "rule": "optional"
                  },
                  "device": {
                    "type": ".squareup.salesreporter.service.Device",
                    "id": 4,
                    "rule": "optional"
                  },
                  "deviceNickname": {
                    "type": ".squareup.salesreporter.service.Device",
                    "id": 16,
                    "rule": "optional"
                  },
                  "channel": {
                    "type": ".squareup.salesreporter.service.Channel",
                    "id": 5,
                    "rule": "optional"
                  },
                  "location": {
                    "type": ".squareup.salesreporter.service.Location",
                    "id": 6,
                    "rule": "optional"
                  },
                  "surchargeType": {
                    "type": ".squareup.salesreporter.service.SurchargeType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "itemCategory": {
                    "type": ".squareup.salesreporter.service.ItemCategory",
                    "id": 8,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "teamMemberCollectedBySingleton": {
                    "type": ".squareup.salesreporter.service.TeamMember",
                    "id": 13,
                    "rule": "optional"
                  },
                  "hourOfDay": {
                    "type": "int32",
                    "id": 11,
                    "rule": "optional"
                  },
                  "dayOfWeek": {
                    "type": ".squareup.salesreporter.service.DayOfWeek",
                    "id": 12,
                    "rule": "optional"
                  },
                  "dayOfWeekV2": {
                    "type": ".squareup.common.time.DayOfWeek",
                    "id": 14,
                    "rule": "optional"
                  },
                  "paymentMethod": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 15,
                    "rule": "optional"
                  },
                  "monthOfYear": {
                    "type": "int32",
                    "id": 17,
                    "rule": "optional"
                  },
                  "year": {
                    "type": "int32",
                    "id": 18,
                    "rule": "optional"
                  },
                  "date": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "hour": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "week": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "month": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "fulfillmentMethod": {
                    "type": ".squareup.salesreporter.service.FulfillmentMethod",
                    "id": 23,
                    "rule": "optional"
                  },
                  "fulfillmentType": {
                    "type": ".squareup.salesreporter.service.FulfillmentType",
                    "id": 24,
                    "rule": "optional"
                  }
                }
              },
              "ReportData": {
                "fields": {
                  "metrics": {
                    "type": ".squareup.salesreporter.service.Metric",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reportDataPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 2,
                    "rule": "optional"
                  },
                  "groupByTypes": {
                    "type": ".squareup.salesreporter.service.GroupByType",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "groupByValues": {
                    "type": ".squareup.salesreporter.service.GroupByValue",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DataSource": {
                "values": {
                  "DATA_SOURCE_DO_NOT_USE": 0,
                  "BEEMO_REPORTER": 1,
                  "SALES_GRAPH": 2,
                  "CUBE": 3
                }
              },
              "NonTransactionalReportRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timelinePeriod": {
                    "type": ".squareup.salesreporter.service.TimelinePeriod",
                    "id": 5,
                    "rule": "optional"
                  },
                  "selectedMetrics": {
                    "type": ".squareup.salesreporter.service.NonTransactionalMetric",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "NonTransactionalMetric": {
                "fields": {
                  "giftCardLoadFees": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instantTransferFees": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "loanPaymentFees": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "NonTransactionalReportData": {
                "fields": {
                  "metrics": {
                    "type": ".squareup.salesreporter.service.NonTransactionalMetric",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reportDataPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "NonTransactionalReportResponse": {
                "fields": {
                  "reportData": {
                    "type": ".squareup.salesreporter.service.NonTransactionalReportData",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PayoutReconciliationReportRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 4,
                    "rule": "optional"
                  },
                  "localReportingHours": {
                    "type": ".squareup.salesreporter.service.LocalTimeInterval",
                    "id": 5,
                    "rule": "optional"
                  },
                  "selectedSalesMetrics": {
                    "type": ".squareup.salesreporter.service.MetricName",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "PayoutReconciliationReportResponse": {
                "fields": {
                  "salesMetrics": {
                    "type": ".squareup.salesreporter.service.Metric",
                    "id": 1,
                    "rule": "optional"
                  },
                  "nonTransferableCollectionsByPaymentMethod": {
                    "type": ".squareup.salesreporter.service.PaymentMethodBreakdown",
                    "id": 2,
                    "rule": "optional"
                  },
                  "transferablePaymentsByPaymentMethod": {
                    "type": ".squareup.salesreporter.service.PaymentMethodBreakdown",
                    "id": 3,
                    "rule": "optional"
                  },
                  "transferableRefundsByPaymentMethod": {
                    "type": ".squareup.salesreporter.service.PaymentMethodBreakdown",
                    "id": 4,
                    "rule": "optional"
                  },
                  "nonSalesFeesByType": {
                    "type": ".squareup.salesreporter.service.NonSalesFeeBreakdown",
                    "id": 5,
                    "rule": "optional"
                  },
                  "expectedPayoutAmount": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "currentPeriodPaymentsPayouts": {
                    "type": ".squareup.salesreporter.service.PayoutStatusBreakdown",
                    "id": 7,
                    "rule": "optional"
                  },
                  "currentPeriodBankPayouts": {
                    "type": ".squareup.salesreporter.service.PayoutStatusBreakdown",
                    "id": 8,
                    "rule": "optional"
                  },
                  "differenceBankToPaymentsAmount": {
                    "type": ".squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "expectedToPaymentsPayoutVerification": {
                    "type": ".squareup.salesreporter.service.ReconciliationVerification",
                    "id": 10,
                    "rule": "optional"
                  },
                  "totalFeesAndDeductionsAmount": {
                    "type": ".squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "noPayoutStatusAmount": {
                    "type": ".squareup.common.Money",
                    "id": 12,
                    "rule": "optional"
                  },
                  "priorPeriodPaymentsPayoutsAmount": {
                    "type": ".squareup.common.Money",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "NonSalesFeeBreakdown": {
                "fields": {
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fees": {
                    "type": ".squareup.salesreporter.service.NonSaleFeeAmount",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "NonSaleFeeAmount": {
                "fields": {
                  "type": {
                    "type": ".squareup.paymentbalances.ActivityType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "payoutId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PayoutStatusBreakdown": {
                "fields": {
                  "paidPayouts": {
                    "type": ".squareup.salesreporter.service.PayoutAmount",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sentPayouts": {
                    "type": ".squareup.salesreporter.service.PayoutAmount",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pendingPayouts": {
                    "type": ".squareup.salesreporter.service.PayoutAmount",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failedPayouts": {
                    "type": ".squareup.salesreporter.service.PayoutAmount",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reportingPeriodTotalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "PayoutAmount": {
                "fields": {
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "payouts": {
                    "type": ".squareup.salesreporter.service.PayoutDetail",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriodTotalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payoutGroups": {
                    "type": ".squareup.salesreporter.service.PayoutDetailGroup",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "PayoutDetail": {
                "fields": {
                  "payoutId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.payouts.PayoutStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "arrivalDate": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reportingPeriodAmount": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "PayoutDetailGroup": {
                "fields": {
                  "status": {
                    "type": ".squareup.payouts.PayoutStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reportingPeriodAmount": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "payouts": {
                    "type": ".squareup.salesreporter.service.PayoutDetail",
                    "id": 6,
                    "rule": "repeated"
                  }
                }
              },
              "ReconciliationVerification": {
                "fields": {
                  "matches": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "difference": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expected": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actual": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "hasIncompleteData": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GetTransferFromPayoutRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferLookups": {
                    "type": ".squareup.salesreporter.service.TransferLookup",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "TransferLookup": {
                "fields": {
                  "locationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "payoutId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetTransferFromPayoutResponse": {
                "fields": {
                  "transfers": {
                    "type": ".squareup.salesreporter.service.TransferInfo",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "TransferInfo": {
                "fields": {
                  "payoutId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ListReportingDetailsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "reportingPeriod": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": ".squareup.salesreporter.service.TimeZone",
                    "id": 4,
                    "rule": "optional"
                  },
                  "localReportingHours": {
                    "type": ".squareup.salesreporter.service.LocalTimeInterval",
                    "id": 5,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": ".squareup.salesreporter.service.FilterByValue",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "pageSize": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "reportingCountMetric": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "ListReportingDetailsResponse": {
                "fields": {
                  "reportingTransactions": {
                    "type": ".squareup.salesreporter.service.ReportingTransaction",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReportingTransaction": {
                "fields": {
                  "merchant": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "location": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "saleTimestamp": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "grossSales": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "itemSales": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "serviceCharges": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "returns": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "discounts": {
                    "type": ".squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "comps": {
                    "type": ".squareup.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "netSales": {
                    "type": ".squareup.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "giftCardSales": {
                    "type": ".squareup.common.Money",
                    "id": 12,
                    "rule": "optional"
                  },
                  "taxes": {
                    "type": ".squareup.common.Money",
                    "id": 13,
                    "rule": "optional"
                  },
                  "tips": {
                    "type": ".squareup.common.Money",
                    "id": 14,
                    "rule": "optional"
                  },
                  "refundsByAmount": {
                    "type": ".squareup.common.Money",
                    "id": 21,
                    "rule": "optional"
                  },
                  "channelId": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "channelName": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "device": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "deviceNickname": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "collectedBy": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "payments": {
                    "type": ".squareup.salesreporter.service.PaymentAmount",
                    "id": 22,
                    "rule": "repeated"
                  },
                  "fulfillmentMethod": {
                    "type": ".squareup.salesreporter.service.FulfillmentMethod",
                    "id": 23,
                    "rule": "optional"
                  },
                  "fulfillmentType": {
                    "type": ".squareup.salesreporter.service.FulfillmentType",
                    "id": 24,
                    "rule": "optional"
                  },
                  "grossSalesMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 25,
                    "rule": "optional"
                  },
                  "serviceChargesOnlySum": {
                    "type": ".squareup.common.Money",
                    "id": 26,
                    "rule": "optional"
                  },
                  "returnsMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 27,
                    "rule": "optional"
                  },
                  "netSalesMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 28,
                    "rule": "optional"
                  },
                  "taxesMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 29,
                    "rule": "optional"
                  },
                  "netSalesWithTaxMinusAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 30,
                    "rule": "optional"
                  },
                  "netAutoGratuity": {
                    "type": ".squareup.common.Money",
                    "id": 31,
                    "rule": "optional"
                  },
                  "tipPlusNetAutoGratuitySum": {
                    "type": ".squareup.common.Money",
                    "id": 32,
                    "rule": "optional"
                  },
                  "netSalesWithTax": {
                    "type": ".squareup.common.Money",
                    "id": 33,
                    "rule": "optional"
                  }
                }
              },
              "PaymentAmount": {
                "fields": {
                  "paymentMethod": {
                    "type": ".squareup.paymentreporter.service.PaymentMethod",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customPaymentTypeName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReportRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TimeZone && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.LocalTimeInterval && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ZonedTimeInterval && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.InternalRequestOptions && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.AvailableFiltersRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PageParams && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReportResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.InternalResponseOptions && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.AvailableFiltersResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PageInfo && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FilterByType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ChannelList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DeviceList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.OrderSourceList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.LocationList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemTypeList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.EmployeeList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.CheckStateList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.CheckStateV2List && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemCategoryList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PaymentMethodList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FulfillmentMethodList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FulfillmentTypeList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FilterByValue && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.Channel && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ChannelType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ChannelScope && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ChannelReference && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.Device && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.OrderSource && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FulfillmentMethod && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FulfillmentType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.Location && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.Employee && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ItemCategory && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.HouseAccountInvoice && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SurchargeType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.CheckState && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.CheckStateV2 && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TranslationType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TeamMemberTranslationTypes && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TeamMemberName && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TeamMember && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TeamMemberList && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NameOrTranslationType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TimelinePeriod && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReportingCounts && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.Metric && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PaymentMethodBreakdown && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PaymentMethodAmount && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FeeBreakdown && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.FeeAmount && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.CustomServiceChargeDetail && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NameToServiceCharge && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TotalCollectedByMethod && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.OtherPaymentBreakdown && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.SourceToCollected && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PaymentMethodToCollected && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ThirdPartyFeeTranslationType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ThirdPartyFeeDetail && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.MetricName && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.GroupByType && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DayOfWeek && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.GroupByValue && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReportData && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.DataSource && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NonTransactionalReportRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NonTransactionalMetric && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NonTransactionalReportData && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NonTransactionalReportResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PayoutReconciliationReportRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PayoutReconciliationReportResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NonSalesFeeBreakdown && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.NonSaleFeeAmount && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PayoutStatusBreakdown && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PayoutAmount && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PayoutDetail && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PayoutDetailGroup && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReconciliationVerification && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.GetTransferFromPayoutRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TransferLookup && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.GetTransferFromPayoutResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.TransferInfo && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ListReportingDetailsRequest && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ListReportingDetailsResponse && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.ReportingTransaction && !$root.nested?.squareup?.nested?.salesreporter?.nested?.service?.nested?.PaymentAmount) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ReportRequest @ squareup/salesreporter/report.proto at 20:1
 */
export const ReportRequest = $root.lookupType('squareup.salesreporter.service.ReportRequest');
fixType(ReportRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  },
  timelinePeriod: {
    required: true
  }
});
Builder.createAndAttachToType(ReportRequest);
/**
 * SOURCE TimeZone @ squareup/salesreporter/report.proto at 89:1
 */
export const TimeZone = $root.lookupType('squareup.salesreporter.service.TimeZone');
fixType(TimeZone, {
  tzName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TimeZone);
/**
 * Represents an interval of LocalTime values.
 *
 * SOURCE LocalTimeInterval @ squareup/salesreporter/report.proto at 105:1
 */
export const LocalTimeInterval = $root.lookupType('squareup.salesreporter.service.LocalTimeInterval');
fixType(LocalTimeInterval);
Builder.createAndAttachToType(LocalTimeInterval);
/**
 * SOURCE ZonedTimeInterval @ squareup/salesreporter/report.proto at 110:1
 */
export const ZonedTimeInterval = $root.lookupType('squareup.salesreporter.service.ZonedTimeInterval');
fixType(ZonedTimeInterval, {
  start: {
    required: true
  },
  end: {
    required: true
  }
});
Builder.createAndAttachToType(ZonedTimeInterval);
/**
 * SOURCE InternalRequestOptions @ squareup/salesreporter/report.proto at 121:1
 */
export const InternalRequestOptions = $root.lookupType('squareup.salesreporter.service.InternalRequestOptions');
fixType(InternalRequestOptions);
Builder.createAndAttachToType(InternalRequestOptions);
/**
 * SOURCE AvailableFiltersRequest @ squareup/salesreporter/report.proto at 132:1
 */
export const AvailableFiltersRequest = $root.lookupType('squareup.salesreporter.service.AvailableFiltersRequest');
fixType(AvailableFiltersRequest, {
  reportingPeriod: {
    required: true
  },
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AvailableFiltersRequest);
/**
 * SOURCE PageParams @ squareup/salesreporter/report.proto at 152:1
 */
export const PageParams = $root.lookupType('squareup.salesreporter.service.PageParams');
fixType(PageParams);
Builder.createAndAttachToType(PageParams);
/**
 * SOURCE ReportResponse @ squareup/salesreporter/report.proto at 159:1
 */
export const ReportResponse = $root.lookupType('squareup.salesreporter.service.ReportResponse');
fixType(ReportResponse);
Builder.createAndAttachToType(ReportResponse);
/**
 * SOURCE InternalResponseOptions @ squareup/salesreporter/report.proto at 168:1
 */
export const InternalResponseOptions = $root.lookupType('squareup.salesreporter.service.InternalResponseOptions');
fixType(InternalResponseOptions);
Builder.createAndAttachToType(InternalResponseOptions);
/**
 * SOURCE AvailableFiltersResponse @ squareup/salesreporter/report.proto at 174:1
 */
export const AvailableFiltersResponse = $root.lookupType('squareup.salesreporter.service.AvailableFiltersResponse');
fixType(AvailableFiltersResponse);
Builder.createAndAttachToType(AvailableFiltersResponse);
/**
 * SOURCE PageInfo @ squareup/salesreporter/report.proto at 179:1
 */
export const PageInfo = $root.lookupType('squareup.salesreporter.service.PageInfo');
fixType(PageInfo);
Builder.createAndAttachToType(PageInfo);
/**
 * SOURCE FilterByType @ squareup/salesreporter/report.proto at 184:1
 */
export const FilterByType = $root.lookupEnum('squareup.salesreporter.service.FilterByType').values;
/**
 * SOURCE ChannelList @ squareup/salesreporter/report.proto at 209:1
 */
export const ChannelList = $root.lookupType('squareup.salesreporter.service.ChannelList');
fixType(ChannelList);
Builder.createAndAttachToType(ChannelList);
/**
 * SOURCE DeviceList @ squareup/salesreporter/report.proto at 213:1
 */
export const DeviceList = $root.lookupType('squareup.salesreporter.service.DeviceList');
fixType(DeviceList);
Builder.createAndAttachToType(DeviceList);
/**
 * SOURCE OrderSourceList @ squareup/salesreporter/report.proto at 217:1
 */
export const OrderSourceList = $root.lookupType('squareup.salesreporter.service.OrderSourceList');
fixType(OrderSourceList);
Builder.createAndAttachToType(OrderSourceList);
/**
 * SOURCE LocationList @ squareup/salesreporter/report.proto at 221:1
 */
export const LocationList = $root.lookupType('squareup.salesreporter.service.LocationList');
fixType(LocationList);
Builder.createAndAttachToType(LocationList);
/**
 * SOURCE ItemTypeList @ squareup/salesreporter/report.proto at 225:1
 */
export const ItemTypeList = $root.lookupType('squareup.salesreporter.service.ItemTypeList');
fixType(ItemTypeList);
Builder.createAndAttachToType(ItemTypeList);
/**
 * SOURCE EmployeeList @ squareup/salesreporter/report.proto at 229:1
 */
export const EmployeeList = $root.lookupType('squareup.salesreporter.service.EmployeeList');
fixType(EmployeeList);
Builder.createAndAttachToType(EmployeeList);
/**
 * SOURCE CheckStateList @ squareup/salesreporter/report.proto at 237:1
 */
export const CheckStateList = $root.lookupType('squareup.salesreporter.service.CheckStateList');
fixType(CheckStateList);
Builder.createAndAttachToType(CheckStateList);
/**
 * SOURCE CheckStateV2List @ squareup/salesreporter/report.proto at 241:1
 */
export const CheckStateV2List = $root.lookupType('squareup.salesreporter.service.CheckStateV2List');
fixType(CheckStateV2List);
Builder.createAndAttachToType(CheckStateV2List);
/**
 * SOURCE ItemCategoryList @ squareup/salesreporter/report.proto at 245:1
 */
export const ItemCategoryList = $root.lookupType('squareup.salesreporter.service.ItemCategoryList');
fixType(ItemCategoryList);
Builder.createAndAttachToType(ItemCategoryList);
/**
 * SOURCE PaymentMethodList @ squareup/salesreporter/report.proto at 249:1
 */
export const PaymentMethodList = $root.lookupType('squareup.salesreporter.service.PaymentMethodList');
fixType(PaymentMethodList);
Builder.createAndAttachToType(PaymentMethodList);
/**
 * SOURCE FulfillmentMethodList @ squareup/salesreporter/report.proto at 253:1
 */
export const FulfillmentMethodList = $root.lookupType('squareup.salesreporter.service.FulfillmentMethodList');
fixType(FulfillmentMethodList);
Builder.createAndAttachToType(FulfillmentMethodList);
/**
 * SOURCE FulfillmentTypeList @ squareup/salesreporter/report.proto at 257:1
 */
export const FulfillmentTypeList = $root.lookupType('squareup.salesreporter.service.FulfillmentTypeList');
fixType(FulfillmentTypeList);
Builder.createAndAttachToType(FulfillmentTypeList);
/**
 * SOURCE FilterByValue @ squareup/salesreporter/report.proto at 261:1
 */
export const FilterByValue = $root.lookupType('squareup.salesreporter.service.FilterByValue');
fixType(FilterByValue);
Builder.createAndAttachToType(FilterByValue);
/**
 * SOURCE Channel @ squareup/salesreporter/report.proto at 293:1
 */
export const Channel = $root.lookupType('squareup.salesreporter.service.Channel');
fixType(Channel);
Builder.createAndAttachToType(Channel);
/**
 * SOURCE ChannelType @ squareup/salesreporter/report.proto at 317:1
 */
export const ChannelType = $root.lookupEnum('squareup.salesreporter.service.ChannelType').values;
/**
 * SOURCE ChannelScope @ squareup/salesreporter/report.proto at 323:1
 */
export const ChannelScope = $root.lookupEnum('squareup.salesreporter.service.ChannelScope').values;
/**
 * SOURCE ChannelReference @ squareup/salesreporter/report.proto at 330:1
 */
export const ChannelReference = $root.lookupType('squareup.salesreporter.service.ChannelReference');
fixType(ChannelReference);
Builder.createAndAttachToType(ChannelReference);
/**
 * SOURCE Device @ squareup/salesreporter/report.proto at 341:1
 */
export const Device = $root.lookupType('squareup.salesreporter.service.Device');
fixType(Device);
Builder.createAndAttachToType(Device);
/**
 * SOURCE OrderSource @ squareup/salesreporter/report.proto at 347:1
 */
export const OrderSource = $root.lookupType('squareup.salesreporter.service.OrderSource');
fixType(OrderSource);
Builder.createAndAttachToType(OrderSource);
/**
 * SOURCE FulfillmentMethod @ squareup/salesreporter/report.proto at 352:1
 */
export const FulfillmentMethod = $root.lookupType('squareup.salesreporter.service.FulfillmentMethod');
fixType(FulfillmentMethod);
Builder.createAndAttachToType(FulfillmentMethod);
/**
 * Maps to GraphQL OrderFulfillmentTypeInput values.
 *
 * SOURCE FulfillmentType @ squareup/salesreporter/report.proto at 357:1
 */
export const FulfillmentType = $root.lookupEnum('squareup.salesreporter.service.FulfillmentType').values;
/**
 * SOURCE Location @ squareup/salesreporter/report.proto at 371:1
 */
export const Location = $root.lookupType('squareup.salesreporter.service.Location');
fixType(Location);
Builder.createAndAttachToType(Location);
/**
 * SOURCE Employee @ squareup/salesreporter/report.proto at 376:1
 */
export const Employee = $root.lookupType('squareup.salesreporter.service.Employee');
fixType(Employee);
Builder.createAndAttachToType(Employee);
/**
 * SOURCE ItemCategory @ squareup/salesreporter/report.proto at 382:1
 */
export const ItemCategory = $root.lookupType('squareup.salesreporter.service.ItemCategory');
fixType(ItemCategory);
Builder.createAndAttachToType(ItemCategory);
/**
 * SOURCE HouseAccountInvoice @ squareup/salesreporter/report.proto at 387:1
 */
export const HouseAccountInvoice = $root.lookupEnum('squareup.salesreporter.service.HouseAccountInvoice').values;
/**
 * SOURCE SurchargeType @ squareup/salesreporter/report.proto at 394:1
 */
export const SurchargeType = $root.lookupEnum('squareup.salesreporter.service.SurchargeType').values;
/**
 * SOURCE CheckState @ squareup/salesreporter/report.proto at 402:1
 */
export const CheckState = $root.lookupEnum('squareup.salesreporter.service.CheckState').values;
/**
 * SOURCE CheckStateV2 @ squareup/salesreporter/report.proto at 412:1
 */
export const CheckStateV2 = $root.lookupEnum('squareup.salesreporter.service.CheckStateV2').values;
/**
 * copy of https://prototype.sqprod.co/#/docs/squareup.beemo.translation_types.TranslationType
 *
 * SOURCE TranslationType @ squareup/salesreporter/report.proto at 424:1
 */
export const TranslationType = $root.lookupEnum('squareup.salesreporter.service.TranslationType').values;
/**
 * SOURCE TeamMemberTranslationTypes @ squareup/salesreporter/report.proto at 551:1
 */
export const TeamMemberTranslationTypes = $root.lookupEnum('squareup.salesreporter.service.TeamMemberTranslationTypes').values;
/**
 * SOURCE TeamMemberName @ squareup/salesreporter/report.proto at 558:1
 */
export const TeamMemberName = $root.lookupType('squareup.salesreporter.service.TeamMemberName');
fixType(TeamMemberName);
Builder.createAndAttachToType(TeamMemberName);
/**
 * SOURCE TeamMember @ squareup/salesreporter/report.proto at 563:1
 */
export const TeamMember = $root.lookupType('squareup.salesreporter.service.TeamMember');
fixType(TeamMember);
Builder.createAndAttachToType(TeamMember);
/**
 * SOURCE TeamMemberList @ squareup/salesreporter/report.proto at 571:1
 */
export const TeamMemberList = $root.lookupType('squareup.salesreporter.service.TeamMemberList');
fixType(TeamMemberList);
Builder.createAndAttachToType(TeamMemberList);
/**
 * copy of https://prototype.sqprod.co/#/docs/squareup.beemo.translation_types.NameOrTranslationType
 *
 * SOURCE NameOrTranslationType @ squareup/salesreporter/report.proto at 576:1
 */
export const NameOrTranslationType = $root.lookupType('squareup.salesreporter.service.NameOrTranslationType');
fixType(NameOrTranslationType);
Builder.createAndAttachToType(NameOrTranslationType);
/**
 * SOURCE TimelinePeriod @ squareup/salesreporter/report.proto at 582:1
 */
export const TimelinePeriod = $root.lookupEnum('squareup.salesreporter.service.TimelinePeriod').values;
/**
 * SOURCE ReportingCounts @ squareup/salesreporter/report.proto at 592:1
 */
export const ReportingCounts = $root.lookupType('squareup.salesreporter.service.ReportingCounts');
fixType(ReportingCounts);
Builder.createAndAttachToType(ReportingCounts);
/**
 * SOURCE Metric @ squareup/salesreporter/report.proto at 620:1
 */
export const Metric = $root.lookupType('squareup.salesreporter.service.Metric');
fixType(Metric);
Builder.createAndAttachToType(Metric);
/**
 * A breakdown of money by payment method, matching the Payment Method report PaymentMethod enum
 *
 * SOURCE PaymentMethodBreakdown @ squareup/salesreporter/report.proto at 705:1
 */
export const PaymentMethodBreakdown = $root.lookupType('squareup.salesreporter.service.PaymentMethodBreakdown');
fixType(PaymentMethodBreakdown);
Builder.createAndAttachToType(PaymentMethodBreakdown);
/**
 * Payment method amount for a specific payment method, using the Payment Method report PaymentMethod enum
 *
 * SOURCE PaymentMethodAmount @ squareup/salesreporter/report.proto at 717:1
 */
export const PaymentMethodAmount = $root.lookupType('squareup.salesreporter.service.PaymentMethodAmount');
fixType(PaymentMethodAmount);
Builder.createAndAttachToType(PaymentMethodAmount);
/**
 * A breakdown of fees by type, matching the Fee Report FeeType enum
 *
 * SOURCE FeeBreakdown @ squareup/salesreporter/report.proto at 729:1
 */
export const FeeBreakdown = $root.lookupType('squareup.salesreporter.service.FeeBreakdown');
fixType(FeeBreakdown);
Builder.createAndAttachToType(FeeBreakdown);
/**
 * Fee amount for a specific fee type, using the Fee Report FeeType enum
 *
 * SOURCE FeeAmount @ squareup/salesreporter/report.proto at 737:1
 */
export const FeeAmount = $root.lookupType('squareup.salesreporter.service.FeeAmount');
fixType(FeeAmount);
Builder.createAndAttachToType(FeeAmount);
/**
 * SOURCE CustomServiceChargeDetail @ squareup/salesreporter/report.proto at 744:1
 */
export const CustomServiceChargeDetail = $root.lookupType('squareup.salesreporter.service.CustomServiceChargeDetail');
fixType(CustomServiceChargeDetail);
Builder.createAndAttachToType(CustomServiceChargeDetail);
/**
 * SOURCE NameToServiceCharge @ squareup/salesreporter/report.proto at 749:1
 */
export const NameToServiceCharge = $root.lookupType('squareup.salesreporter.service.NameToServiceCharge');
fixType(NameToServiceCharge);
Builder.createAndAttachToType(NameToServiceCharge);
/**
 * SOURCE TotalCollectedByMethod @ squareup/salesreporter/report.proto at 754:1
 */
export const TotalCollectedByMethod = $root.lookupType('squareup.salesreporter.service.TotalCollectedByMethod');
fixType(TotalCollectedByMethod);
Builder.createAndAttachToType(TotalCollectedByMethod);
/**
 * SOURCE OtherPaymentBreakdown @ squareup/salesreporter/report.proto at 764:1
 */
export const OtherPaymentBreakdown = $root.lookupType('squareup.salesreporter.service.OtherPaymentBreakdown');
fixType(OtherPaymentBreakdown);
Builder.createAndAttachToType(OtherPaymentBreakdown);
/**
 * SOURCE SourceToCollected @ squareup/salesreporter/report.proto at 768:1
 */
export const SourceToCollected = $root.lookupType('squareup.salesreporter.service.SourceToCollected');
fixType(SourceToCollected);
Builder.createAndAttachToType(SourceToCollected);
/**
 * SOURCE PaymentMethodToCollected @ squareup/salesreporter/report.proto at 773:1
 */
export const PaymentMethodToCollected = $root.lookupType('squareup.salesreporter.service.PaymentMethodToCollected');
fixType(PaymentMethodToCollected);
Builder.createAndAttachToType(PaymentMethodToCollected);
/**
 * SOURCE ThirdPartyFeeTranslationType @ squareup/salesreporter/report.proto at 787:1
 */
export const ThirdPartyFeeTranslationType = $root.lookupEnum('squareup.salesreporter.service.ThirdPartyFeeTranslationType').values;
/**
 * SOURCE ThirdPartyFeeDetail @ squareup/salesreporter/report.proto at 792:1
 */
export const ThirdPartyFeeDetail = $root.lookupType('squareup.salesreporter.service.ThirdPartyFeeDetail');
fixType(ThirdPartyFeeDetail);
Builder.createAndAttachToType(ThirdPartyFeeDetail);
/**
 * SOURCE MetricName @ squareup/salesreporter/report.proto at 808:1
 */
export const MetricName = $root.lookupEnum('squareup.salesreporter.service.MetricName').values;
/**
 * SOURCE GroupByType @ squareup/salesreporter/report.proto at 1015:1
 */
export const GroupByType = $root.lookupEnum('squareup.salesreporter.service.GroupByType').values;
/**
 * SOURCE DayOfWeek @ squareup/salesreporter/report.proto at 1052:1
 */
export const DayOfWeek = $root.lookupEnum('squareup.salesreporter.service.DayOfWeek').values;
/**
 * SOURCE GroupByValue @ squareup/salesreporter/report.proto at 1063:1
 */
export const GroupByValue = $root.lookupType('squareup.salesreporter.service.GroupByValue');
fixType(GroupByValue);
Builder.createAndAttachToType(GroupByValue);
/**
 * SOURCE ReportData @ squareup/salesreporter/report.proto at 1092:1
 */
export const ReportData = $root.lookupType('squareup.salesreporter.service.ReportData');
fixType(ReportData);
Builder.createAndAttachToType(ReportData);
/**
 * SOURCE DataSource @ squareup/salesreporter/report.proto at 1099:1
 */
export const DataSource = $root.lookupEnum('squareup.salesreporter.service.DataSource').values;
/**
 * SOURCE NonTransactionalReportRequest @ squareup/salesreporter/report.proto at 1119:1
 */
export const NonTransactionalReportRequest = $root.lookupType('squareup.salesreporter.service.NonTransactionalReportRequest');
fixType(NonTransactionalReportRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  },
  timelinePeriod: {
    required: true
  }
});
Builder.createAndAttachToType(NonTransactionalReportRequest);
/**
 * SOURCE NonTransactionalMetric @ squareup/salesreporter/report.proto at 1144:1
 */
export const NonTransactionalMetric = $root.lookupType('squareup.salesreporter.service.NonTransactionalMetric');
fixType(NonTransactionalMetric);
Builder.createAndAttachToType(NonTransactionalMetric);
/**
 * SOURCE NonTransactionalReportData @ squareup/salesreporter/report.proto at 1150:1
 */
export const NonTransactionalReportData = $root.lookupType('squareup.salesreporter.service.NonTransactionalReportData');
fixType(NonTransactionalReportData);
Builder.createAndAttachToType(NonTransactionalReportData);
/**
 * SOURCE NonTransactionalReportResponse @ squareup/salesreporter/report.proto at 1155:1
 */
export const NonTransactionalReportResponse = $root.lookupType('squareup.salesreporter.service.NonTransactionalReportResponse');
fixType(NonTransactionalReportResponse);
Builder.createAndAttachToType(NonTransactionalReportResponse);
/**
 * SOURCE PayoutReconciliationReportRequest @ squareup/salesreporter/report.proto at 1160:1
 */
export const PayoutReconciliationReportRequest = $root.lookupType('squareup.salesreporter.service.PayoutReconciliationReportRequest');
fixType(PayoutReconciliationReportRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  }
});
Builder.createAndAttachToType(PayoutReconciliationReportRequest);
/**
 * SOURCE PayoutReconciliationReportResponse @ squareup/salesreporter/report.proto at 1185:1
 */
export const PayoutReconciliationReportResponse = $root.lookupType('squareup.salesreporter.service.PayoutReconciliationReportResponse');
fixType(PayoutReconciliationReportResponse);
Builder.createAndAttachToType(PayoutReconciliationReportResponse);
/**
 * A breakdown of non-sale fees by type, matching payouts.PayoutEntry.type ActivityType enum
 *
 * SOURCE NonSalesFeeBreakdown @ squareup/salesreporter/report.proto at 1218:1
 */
export const NonSalesFeeBreakdown = $root.lookupType('squareup.salesreporter.service.NonSalesFeeBreakdown');
fixType(NonSalesFeeBreakdown);
Builder.createAndAttachToType(NonSalesFeeBreakdown);
/**
 * Fee amount for a specific fee type, using the payouts.PayoutEntry.type ActivityType enum
 *
 * SOURCE NonSaleFeeAmount @ squareup/salesreporter/report.proto at 1226:1
 */
export const NonSaleFeeAmount = $root.lookupType('squareup.salesreporter.service.NonSaleFeeAmount');
fixType(NonSaleFeeAmount);
Builder.createAndAttachToType(NonSaleFeeAmount);
/**
 * Payouts split out by PayoutStatus: https://prototype.sqprod.co/#/docs/squareup.payouts.PayoutStatus
 *
 * SOURCE PayoutStatusBreakdown @ squareup/salesreporter/report.proto at 1236:1
 */
export const PayoutStatusBreakdown = $root.lookupType('squareup.salesreporter.service.PayoutStatusBreakdown');
fixType(PayoutStatusBreakdown);
Builder.createAndAttachToType(PayoutStatusBreakdown);
/**
 * SOURCE PayoutAmount @ squareup/salesreporter/report.proto at 1251:1
 */
export const PayoutAmount = $root.lookupType('squareup.salesreporter.service.PayoutAmount');
fixType(PayoutAmount);
Builder.createAndAttachToType(PayoutAmount);
/**
 * Payout detail information from the Payout proto: https://prototype.sqprod.co/#/docs/squareup.payouts.Payout
 *
 * SOURCE PayoutDetail @ squareup/salesreporter/report.proto at 1263:1
 */
export const PayoutDetail = $root.lookupType('squareup.salesreporter.service.PayoutDetail');
fixType(PayoutDetail);
Builder.createAndAttachToType(PayoutDetail);
/**
 * Groups PayoutDetail objects by their creation date (day), location ID, and status
 *
 * SOURCE PayoutDetailGroup @ squareup/salesreporter/report.proto at 1281:1
 */
export const PayoutDetailGroup = $root.lookupType('squareup.salesreporter.service.PayoutDetailGroup');
fixType(PayoutDetailGroup);
Builder.createAndAttachToType(PayoutDetailGroup);
/**
 * SOURCE ReconciliationVerification @ squareup/salesreporter/report.proto at 1296:1
 */
export const ReconciliationVerification = $root.lookupType('squareup.salesreporter.service.ReconciliationVerification');
fixType(ReconciliationVerification);
Builder.createAndAttachToType(ReconciliationVerification);
/**
 * SOURCE GetTransferFromPayoutRequest @ squareup/salesreporter/report.proto at 1307:1
 */
export const GetTransferFromPayoutRequest = $root.lookupType('squareup.salesreporter.service.GetTransferFromPayoutRequest');
fixType(GetTransferFromPayoutRequest, {
  merchantToken: {
    notEmpty: true
  },
  transferLookups: {
    required: true
  }
});
Builder.createAndAttachToType(GetTransferFromPayoutRequest);
/**
 * SOURCE TransferLookup @ squareup/salesreporter/report.proto at 1312:1
 */
export const TransferLookup = $root.lookupType('squareup.salesreporter.service.TransferLookup');
fixType(TransferLookup, {
  locationId: {
    notEmpty: true
  },
  payoutId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferLookup);
/**
 * SOURCE GetTransferFromPayoutResponse @ squareup/salesreporter/report.proto at 1319:1
 */
export const GetTransferFromPayoutResponse = $root.lookupType('squareup.salesreporter.service.GetTransferFromPayoutResponse');
fixType(GetTransferFromPayoutResponse);
Builder.createAndAttachToType(GetTransferFromPayoutResponse);
/**
 * SOURCE TransferInfo @ squareup/salesreporter/report.proto at 1323:1
 */
export const TransferInfo = $root.lookupType('squareup.salesreporter.service.TransferInfo');
fixType(TransferInfo);
Builder.createAndAttachToType(TransferInfo);
/**
 * SOURCE ListReportingDetailsRequest @ squareup/salesreporter/report.proto at 1332:1
 */
export const ListReportingDetailsRequest = $root.lookupType('squareup.salesreporter.service.ListReportingDetailsRequest');
fixType(ListReportingDetailsRequest, {
  merchantToken: {
    notEmpty: true
  },
  reportingPeriod: {
    required: true
  }
});
Builder.createAndAttachToType(ListReportingDetailsRequest);
/**
 * SOURCE ListReportingDetailsResponse @ squareup/salesreporter/report.proto at 1349:1
 */
export const ListReportingDetailsResponse = $root.lookupType('squareup.salesreporter.service.ListReportingDetailsResponse');
fixType(ListReportingDetailsResponse);
Builder.createAndAttachToType(ListReportingDetailsResponse);
/**
 * SOURCE ReportingTransaction @ squareup/salesreporter/report.proto at 1355:1
 */
export const ReportingTransaction = $root.lookupType('squareup.salesreporter.service.ReportingTransaction');
fixType(ReportingTransaction);
Builder.createAndAttachToType(ReportingTransaction);
/**
 * Amount collected or refunded for a specific payment method.
 *
 * SOURCE PaymentAmount @ squareup/salesreporter/report.proto at 1404:1
 */
export const PaymentAmount = $root.lookupType('squareup.salesreporter.service.PaymentAmount');
fixType(PaymentAmount);
Builder.createAndAttachToType(PaymentAmount);